module.exports = __webpack_public_path__ + "static/media/9-9.7ffaf7f5.mp3";